<template>
<div class="h-full flex flex-row">
    <div class="flex flex-col w-3/5 pr-16 justify-center items-center border-r-2">
        <h1 class="text-grey-darker">{{this.titleMessage}}</h1>
        <!-- <h3 class="text-grey-dark text-base mt-4">{{this.subtitleMessage}}</h3> -->
        
        <div class="flex flex-row h-16 my-6 p-4 rounded-full items-center justify-center shadow cursor-pointer hover:shadow-md" @click="loginUserWithGoogle">
            <svg class="h-10 w-10" 
              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 48 48"><defs>
              <path id="a" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"/></clipPath><path clip-path="url(#b)" fill="#FBBC05" d="M0 37V11l17 13z"/><path clip-path="url(#b)" fill="#EA4335" d="M0 11l17 13 7-6.1L48 14V0H0z"/><path clip-path="url(#b)" fill="#34A853" d="M0 37l30-23 7.9 1L48 0v48H0z"/><path clip-path="url(#b)" fill="#4285F4" d="M48 48L17 24l-4-3 35-10z"/>
            </svg>
            <span class="ml-2 text-sm font-bold text-grey-darker">Login with Google</span>
        </div>

        <div class="text-sm w-sm py-2 px-6 text-grey-dark leading-tight justify-center">
          {{this.descriptionMessage}}
        </div>
    </div>

    <div class="flex flex-col w-2/5 pl-16 justify-center items-center">
        <h1 class="text-grey-dark">Join the beta</h1>
          <div class="text-sm w-sm py-4 px-6 text-grey-darker text-center leading-tight">
          {{this.betaMessage}}
        </div>
        <form class="w-full max-w-xs mt-4">
          <input id="betaInput" 
          @input="validateEmail" 
          @change="validateEmail" 
          v-model="betaEmail" 
          class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded-full w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-light" type="text" placeholder="email@example.com"
          v-bind:class="{ 'border-2 border-green-light': betaSignupSuccess, 'focus:border-red-light': betaSignupError}"
          >
          
          <div class="flex justify-end mt-4">
                <button 
                :disabled="!isEmailValid" 
                class="shadow bg-blue-light rounded-full text-white font-bold py-2 px-4 rounded opacity-50" 
                v-bind:class="{ 'opacity-100 hover:bg-blue hover:shadow-md focus:outline-none': isEmailValid, 'cursor-pointer': isEmailValid, 'cursor-not-allowed': !isEmailValid}"
                type="button" @click="submitBeta">
                Submit
                </button>
          </div>
        </form>
    </div>
</div>
</template>

<script>
import AuthController from "../controllers/AuthController";
import NewsletterRepository from "../repositories/NewsletterRepository";

export default {
  name: "Welcome",
  data() {
    return {
      email: "",
      password: "",

      isEmailValid: false,
      betaEmail: "",
      betaSignupSuccess: false,
      betaSignupError: false,

      isLoginButtonLoading: false,
      isLoginButtonDisabled: false,

      isGoogleLoading: false,
      isGoogleDisabled: false,

      isTwitterLoading: false,
      isTwitterDisabled: false,

      isFacebookLoading: false,
      isFacebookDisabled: false,

      useEmailMessage:
        "if you wish to use email, you need to create an account first.",
      loginButtonText: "login",
      titleMessage: "Welcome to photobooks,",
      subtitleMessage: "login with your google account",
      betaMessage: "Stay in the loop, get early access to new features, premium support and exclusive bonuses.",
      descriptionMessage: "share, manage, grow.",

      placeholderEmail: "email",
      placeholderPassword: "password"
    };
  },

  methods: {
    validateEmail() {
      this.isEmailValid = /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(
        this.betaEmail
      );
      this.betaSignupSuccess = false;
      this.betaSignupError = false;
    },

    submitBeta() {
      NewsletterRepository.registerBetaEntry(this.betaEmail)
        .then(() => {
          console.log("Writtes with success");
          this.betaSignupSuccess = true;
          this.betaSignupError = false;
        })
        .catch(error => {
          console.log("Failed " + error);
          this.betaSignupSuccess = false;
          this.betaSignupError = true;
        });
    },

    toggleLoginButtonLoading(isLoading = false) {
      this.isLoginButtonLoading = isLoading;
    },

    toggleGoogleLoading(isLoading = false) {
      this.isGoogleLoading = isLoading;
    },

    toggleFacebookLoading(isLoading = false) {
      this.isFacebookLoading = isLoading;
    },

    toggleTwitterLoading(isLoading = false) {
      this.isTwitterLoading = isLoading;
    },

    onLoginSuccess() {
      this.email = "";
      this.password = "";
      this.$router.replace("gallery");
    },

    onLoginError(errorMessage) {
      alert("Error " + errorMessage);
      this.toggleLoginButtonLoading();
      this.toggleFacebookLoading();
      this.toggleFacebookLoading();
    },

    loginUserWithEmail() {
      this.toggleLoginButtonLoading(true);
      AuthController.loginWithEmail(this.email, this.password)
        .then(() => {
          this.toggleLoginButtonLoading();
          this.onLoginSuccess();
        })
        .catch(error => {
          this.toggleLoginButtonLoading();
          this.onLoginError(error.message);
        });
    },

    loginUserWithGoogle() {
      this.toggleGoogleLoading(true);
      AuthController.login("google")
        .then(() => {
          this.toggleGoogleLoading();
          this.onLoginSuccess();
        })
        .catch(error => {
          this.toggleGoogleLoading();
          this.onLoginError(error.message);
        });
    },

    loginUserWithFacebook() {
      this.toggleFacebookLoading(true);
      AuthController.login("facebook")
        .then(() => {
          this.toggleFacebookLoading();
          this.onLoginSuccess();
        })
        .catch(error => {
          this.toggleFacebookLoading();
          this.onLoginError(error.message);
        });
    },

    loginUserWithTwitter() {
      this.toggleTwitterLoading(true);
      AuthController.login("twitter")
        .then(() => {
          this.toggleTwitterLoading();
          this.onLoginSuccess();
        })
        .catch(error => {
          this.toggleTwitterLoading();
          this.onLoginError(error.message);
        });
    }

    // TODO
    /**
      linkAccountToProviders(email) {
        auth.fetchProvidersForEmail(email).then(providers => {
          // Step 3.
          // If the user has several providers,
          // the first provider in the list will be the "recommended" provider to use.
          if (providers[0] === 'password') {
            // Asks the user his password.
            // In real scenario, you should handle this asynchronously.
            var password = promptUserForPassword(); // TODO: implement promptUserForPassword.
            auth.signInWithEmailAndPassword(email, password).then(function(user) {
              // Step 4a.
              return user.link(pendingCred);
            }).then(function() {
              // Facebook account successfully linked to the existing Firebase user.
              goToApp();
            });
            return;
          }
          // All the other cases are external providers.
          // Construct provider object for that provider.
          // TODO: implement getProviderForProviderId.
          var provider = getProviderForProviderId(providers[0]);
          // At this point, you should let the user know that he already has an account
          // but with a different provider, and let him validate the fact he wants to
          // sign in with this provider.
          // Sign in to provider. Note: browsers usually block popup triggered asynchronously,
          // so in real scenario you should ask the user to click on a "continue" button
          // that will trigger the signInWithPopup.
          auth.signInWithPopup(provider).then(function(result) {
            // Remember that the user may have signed in with an account that has a different email
            // address than the first one. This can happen as Firebase doesn't control the provider's
            // sign in flow and the user is free to login using whichever account he owns.
            // Step 4b.
            // Link to Facebook credential.
            // As we have access to the pending credential, we can directly call the link method.
            result.user.link(pendingCred).then(function() {
              // Facebook account successfully linked to the existing Firebase user.
              goToApp();
            });
          });
        });
      }*/
  }
};
</script>


// WEBPACK FOOTER //
// src/components/BetaWelcome.vue